import { render, staticRenderFns } from "./childForward.vue?vue&type=template&id=287787bb&scoped=true"
import script from "./childForward.vue?vue&type=script&lang=js"
export * from "./childForward.vue?vue&type=script&lang=js"
import style0 from "./childForward.vue?vue&type=style&index=0&id=287787bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287787bb",
  null
  
)

export default component.exports